import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const NavigateToLoginWithRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      to={`/auth/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
    />
  );
};
